/**
 * Annual plan pricing shown on the purchase-plan and Auto-Renew pages. All
 * prices come from Super Admin Plan Management; only the crossed-out price
 * is calculated here.
 */

/**
 * Whether a plan is a yearly plan, on either page. Plan Management plans say
 * so with validity_days (/purchase-plan); the Auto-Renew list says so with
 * billing_period (/subscription). One check, so both pages agree.
 * @param {{ validity_days?: number|string, billing_period?: string }} plan
 * @returns {boolean}
 */
export const isYearlyPlan = (plan) => !!plan
    && (Number(plan.validity_days) === 365 || plan.billing_period === 'yearly');

/**
 * The crossed-out ("original") price is 12 months at one tenth of the yearly
 * price, with the monthly amount rounded to the nearest rupee first. It is
 * display-only and not stored; the same formula is used on mytamilkart.com
 * (landing page and /plan) and previewed in Super Admin Plan Management, so
 * every page shows the same crossed-out price for a plan.
 * @param {number|string} price yearly price in rupees
 * @returns {number|null} null when there is no valid price
 */
export const crossedOutPrice = (price) => {
    const amount = Number(price); // "" and null become 0, rejected below
    if (!Number.isFinite(amount) || amount <= 0) return null;
    return Math.round(amount / 10) * 12;
};
